<div class="container">
  <div style="background-color: #fce8e8;" class="connectionContainer">
    <img
      style="margin-top: 20px"
      src="../../../../../assets/images/svg/cross_circle.svg"
      alt="cross error"
    />
    <p style="color: #3b3c40" class="connectionText">{{ "bank_connection_failure_retry_title" | translate }}</p>
  </div>
  <div style="background-color: #fce8e8" class="skewEffect"></div>

  <div class="canCloseTabContainer">
    <p style="margin-bottom: 25px">
      {{ "webauth_connection_ok_can_close_popup" | translate }}
    </p>
    <button (click)="closeTab()" class="closeTab">
      {{ "common_closeTab" | translate }}
    </button>
  </div>
</div>